import { FC } from 'react';

import Form from '@/shared/components/forms/PlatformForm';
import PlatformSelect from '@/shared/components/forms/PlatformSelect';

import { getSearchFilterFieldMetadata } from '../../../../../../../02-Companies/01-CompaniesSearch/layout/02-FiltersRow/filterFieldMetadata';

interface LanguageProps {
    filters: Record<string, unknown>;
    handleChange: (path: string[], value: unknown) => void;
}

const Language: FC<LanguageProps> = ({ filters, handleChange }): JSX.Element => (
    <Form>
        <Form.Item label='Languages' style={{ marginBottom: 0 }}>
            <PlatformSelect
                allowClear
                mode='tags'
                options={getSearchFilterFieldMetadata('searchDomains.documents.languages')?.options}
                onChange={(value) => handleChange(['languages'], value)}
                placeholder='Add Languages...'
                style={{ width: '100%' }}
                value={Array.isArray(filters.languages) ? filters.languages.map(String) : []}
            />
        </Form.Item>
    </Form>
);

export default Language;
